// FAZ-10.6 / K-40 — blok başı scoped CSS'i (`resolveBlockStyle` media query'leri +
// grid mobil-yığma) `document.head`'e yönetilen `<style>` olarak enjekte eder.
// Blok ağacına `<style>` düğümü koymak yerine head kullanmak: (a) textContent
// kirliliği yok (arama/önizleme metnine CSS sızmaz); (b) aynı scoped class'ı
// paylaşan bloklar tek kural (refcount'lu, unmount'ta temizlenir).

import { useEffect } from 'react';

const REFS = new Map<string, number>();

/** `id` (scoped class veya sabit anahtar) → `css` kuralını head'e ekler; refcount'lu. */
export function useHeadStyle(id: string | undefined, css: string | undefined): void {
  useEffect(() => {
    if (!id || !css || typeof document === 'undefined') return undefined;
    const current = REFS.get(id) ?? 0;
    if (current === 0) {
      const el = document.createElement('style');
      el.setAttribute('data-cs-style', id);
      el.textContent = css;
      document.head.appendChild(el);
    }
    REFS.set(id, current + 1);
    return () => {
      const next = (REFS.get(id) ?? 1) - 1;
      if (next <= 0) {
        REFS.delete(id);
        document.head.querySelector(`style[data-cs-style="${CSS.escape(id)}"]`)?.remove();
      } else {
        REFS.set(id, next);
      }
    };
  }, [id, css]);
}
